import { Link } from 'react-router-dom';
export default function NotFound(){return <main className="page empty-page"><div className="empty-card"><h1>404</h1><p>Halaman tidak ditemukan.</p><Link className="btn primary" to="/">Kembali</Link></div></main>}
